import classNames from "classnames";
import {
  Container,
  Heading4,
  ImageLite,
  PageLink,
  Paragraph,
} from "shared/components";

import styles from "./Content0802.module.scss";

export const Content0802 = ({ payload }) => {
  const title = payload?.title ?? "";
  const image = payload?.preview ?? {};
  const position = payload?.position ?? "left";
  const { buttonText, link } = payload?.button ?? {};

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={classNames(styles.block, styles[position])}>
          <div className={styles.content}>
            <Heading4 className={styles.title} color="light">
              {title}
            </Heading4>
            <PageLink link={link} className={styles.link}>
              <span className={styles.button}>
                <Paragraph
                  color="light"
                  appearance="bigger"
                  className={styles.label}
                >
                  {buttonText}
                </Paragraph>
              </span>
            </PageLink>
          </div>
          <div className={styles.preview}>
            <ImageLite image={image} className={styles.image} />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Content0802;
